import React from 'react';
import logger from '../utils/logger';
import i18n from '../i18n/i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    try {
      sessionStorage.removeItem('jsonData');
    } catch {
      /* ignore */
    }
    window.location.href = '/home';
  };

  render() {
    if (this.state.hasError) {
      const detail = this.state.error?.message || String(this.state.error || '');
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
          <div className="text-center p-8 bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 max-w-md w-full">
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">
              {i18n.t('common.errorBoundary.title', 'Something went wrong')}
            </h2>
            <p className="text-slate-600 dark:text-slate-300 mb-4 text-sm leading-relaxed">
              {i18n.t('common.errorBoundary.body', "We're sorry, but something unexpected happened. Please try refreshing the page.")}
            </p>
            {detail ? (
              <p className="mb-6 text-start text-xs font-mono text-red-700 dark:text-red-300 bg-red-50 dark:bg-red-950/40 border border-red-100 dark:border-red-900/50 rounded-lg p-3 break-words">
                {detail}
              </p>
            ) : null}
            <div className="flex flex-col sm:flex-row gap-2 justify-center">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="px-4 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors text-sm font-semibold"
              >
                {i18n.t('common.errorBoundary.refresh', 'Refresh Page')}
              </button>
              <button
                type="button"
                onClick={this.handleReset}
                className="px-4 py-2.5 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-sm font-semibold"
              >
                {i18n.t('common.errorBoundary.goHome', 'Go home')}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
